import moment from "moment";
import React, { useMemo, useRef } from "react";
import { InputGroup } from "react-bootstrap";
import MaskedInput from "react-text-mask";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

type SectionPropTypes = {
  name: string;
  value: any;
  error: any;
  setError: any;
  rawValue: any;
  setRawValue: any;
  setFieldValue: any;
  errorMessage: string;
  restrictDate: any;
  touched: any;
  errors: any;
};

function DatePickers({ name, value, error, setError, rawValue, setRawValue, setFieldValue, errorMessage, restrictDate, touched, errors }: SectionPropTypes) {
  const datepickerRef = useRef<any>(null);
  const dateFieldValue = useMemo(() => {
    if (value) {
      return value;
    }
    return "";
  }, [value]);

  const isValidDate = (dateString: any) => {
    const date: any = new Date(dateString);
    const restricDateString: any = new Date(restrictDate);
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(date) && date.getTime() > restricDateString.getTime()) {
      setError(errorMessage);
    }
    // eslint-disable-next-line no-restricted-globals
    return !isNaN(date) && date.getTime() < restricDateString.getTime();
  };

  const handleCreatedDateFilter = (date: any) => {
    const noNextDate = date.isValid() && isValidDate(date.format("YYYY-MM-DD"));
    if (noNextDate) {
      setError(false);
      setFieldValue(`${name}`, date.format("MM/DD/YYYY"));
    } else if (!noNextDate) {
      setFieldValue(`${name}`, "");
    }
  };

  const maxAllowedYear = new Date().getFullYear();

  const handleClickDatepickerIcon = () => {
    if (datepickerRef.current) {
      datepickerRef.current.setOpen(true);
    }
  };
  const handledateString = (e: any) => {
    setRawValue(e.target.value);
  };

  return (
    <>
      <InputGroup className="flex-nowrap">
        <DatePicker
          name={name}
          onChange={(val: any) => {
            handleCreatedDateFilter(moment(val));
          }}
          portalId="root"
          popperProps={{
            strategy: "fixed"
          }}
          value={rawValue || dateFieldValue}
          selected={isValidDate(dateFieldValue) ? new Date(dateFieldValue) : null}
          className="form-control"
          placeholderText="mm/dd/yyyy"
          dateFormat="MM/dd/yyyy"
          showIcon
          showFullMonthYearPicker
          showYearDropdown
          showMonthDropdown
          dateFormatCalendar="MMMM"
          autoComplete="off"
          yearDropdownItemNumber={100}
          scrollableYearDropdown
          maxDate={new Date(maxAllowedYear, 11, 31)}
          customInput={<MaskedInput mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]} keepCharPositions guide />}
          onChangeRaw={(e: any) => {
            handledateString(e);
            handleCreatedDateFilter(moment(e.target.value));
          }}
          onBlur={() => {
            if (rawValue?.length > 0 && moment(rawValue).isValid()) {
              if (!isValidDate(rawValue)) {
                setError(errorMessage);
              } else {
                setError(false);
              }
            } else if (rawValue?.length > 0) setError("Date should be in proper format mm/dd/yyyy");
            if (!rawValue?.length) setError(false);
          }}
          ref={(pickerRef: any) => {
            datepickerRef.current = pickerRef;
          }}
        />
        <InputGroup.Text>
          {isValidDate(dateFieldValue) && (
            <i
              className="fa-regular fa fa-close mr-2 cursor-pointer text-danger"
              onClick={() => {
                handleCreatedDateFilter(moment(null));
                setRawValue("");
              }}
              aria-hidden="true"
            />
          )}
          <i
            aria-hidden
            className="fa-regular fa-calendar-days"
            onClick={handleClickDatepickerIcon}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                handleClickDatepickerIcon();
              }
            }}
          />
        </InputGroup.Text>
      </InputGroup>
      {(error || (touched?.birthday && errors?.birthday)) && <p className="errorMsg">{error || errors?.birthday}</p>}
    </>
  );
}
export default DatePickers;
